import React, { useState } from 'react'
import { cn } from '../../../../lib/utils'
import { Button } from '../../../../lib/ui/button'
import { apiPost } from '../../../../util/api'
import AylaResponseScrollArea from '../../AylaResponseScrollArea'
import SavedStatusIcon from '~/components/shared/SavedStatusIcon'
import AylaLoading from '~/components/shared/AylaLoading'
import useTranslation, {
  TranslationProvider,
} from '../../../shared/TranslationProvider'
import translations from '../../locales.json'

const IndustryResearch = (props) => {
  const { rankedIndustries, documentId, ctaText, locale } = props

  return (
    <TranslationProvider
      locale={locale}
      translations={translations}
      scope={
        'javascript.components.ShortCourses.WorkEnvironment.IndustryResearch'
      }
    >
      <IndustryResearchInner
        rankedIndustries={rankedIndustries}
        documentId={documentId}
        ctaText={ctaText}
      />
    </TranslationProvider>
  )
}

const IndustryResearchInner = ({ rankedIndustries, documentId, ctaText }) => {
  const [selectedIndustry, setSelectedIndustry] = useState()
  const [submitted, setSubmitted] = useState(false)
  const [typingComplete, setTypingComplete] = useState(false)
  const [displayedText, setDisplayedText] = useState('')
  const [index, setIndex] = useState(0)
  const [aylaResponse, setAylaResponse] = useState(null)
  const [loadingStatus, setLoadingStatus] = useState(null)
  const radioInputClasses = cn(
    '!mb-1 !mr-2 !mt-0 h-4 w-4 border-gray-300 text-blue-600',
  )
  const showCursor = submitted && displayedText.length <= 0
  const showBorder = submitted || aylaResponse
  const { t } = useTranslation('')

  const prompt = t('ayla_prompt', { selected_industry: selectedIndustry })

  const requestAylaStatement = async () => {
    const url = `/job-search/create_ai_response?document_id=${documentId}`
    const data = { ayla_prompt: { prompt } }
    let res
    try {
      res = await apiPost(url, data)
    } catch (err) {
      console.log(err)
    }

    if (res.status === 200) {
      setAylaResponse(res.data.ayla_response)
      setSubmitted(false)
      setLoadingStatus('complete')
    } else {
      console.log('error')
    }
    return res
  }

  const handleButtonClick = () => {
    if (selectedIndustry) {
      setAylaResponse(null)
      setLoadingStatus('loading')
      setDisplayedText('')
      setIndex(0)
      setTypingComplete(false)
      setSubmitted(true)
      requestAylaStatement()
    }
  }

  return (
    <div>
      <div className="flex items-end justify-between rounded-[8px] border border-[#D3D3D3] bg-[#F7FAFC] p-3">
        <fieldset>
          <div className="flex flex-col">
            {rankedIndustries.map((industry) => (
              <div key={industry.id}>
                <input
                  className={radioInputClasses}
                  type="radio"
                  id={industry.id}
                  name="selected_industry"
                  value={industry.name}
                  onChange={(e) => setSelectedIndustry(e.target.value)}
                />
                <label htmlFor={industry.id}>{industry.name}</label>
              </div>
            ))}
          </div>
        </fieldset>
        <Button disabled={submitted} onClick={handleButtonClick}>
          {ctaText}
          <SavedStatusIcon loadingStatus={loadingStatus} />
        </Button>
      </div>
      {loadingStatus === 'loading' && (
        <div className="flex items-center justify-center">
          <AylaLoading />
        </div>
      )}
      {loadingStatus === 'complete' && (
        <AylaResponseScrollArea
          showBorder={showBorder}
          showCursor={showCursor}
          aylaResponse={aylaResponse}
          typingComplete={typingComplete}
          setTypingComplete={setTypingComplete}
          displayedText={displayedText}
          setDisplayedText={setDisplayedText}
          index={index}
          setIndex={setIndex}
        />
      )}
    </div>
  )
}
export default IndustryResearch
